const getters = {
  token: state => state.user.token,
  refreshToken: state => state.user.refreshToken,
  loginInfo: state => state.user.loginInfo,
  oaMessage: state => state.user.oaMessage,
  userInfo: state => state.user.userInfo,
  portalInfo: state => state.user.portalInfo,
  advList: state => state.advMoudel.advList, // 广告列表
  moudelsList: state => state.advMoudel.moudelsList, // 模块列表
  activeNameTag: state => state.advMoudel.activeNameTag, // 模块列表
  hearderNavList: state => state.user.hearderNavList, // 头部导航
  footerNavList: state => state.user.footerNavList, // 底部导航
  orgList: state => state.user.orgList // 机构列表
};
export default getters;

